import { Ds } from "@accurx/design";

import { CharLimitErrorMessage } from "../../components";
import { reduceReminderMessage } from "../../utils/reminderFormValidation";
import {
    FragmentsText,
    RoundedMessageBox,
    VerticalResizeTextarea,
} from "../AppointmentReminder.styles";

type ComposeFieldProps = {
    messageParts: {
        greeting: string;
        templateText: string;
        linkText: string;
        messageSignoff: string;
    };
    charAndFragmentInfo: string;
    customMessage: string;
    onCustomMessageChange: React.ChangeEventHandler<HTMLTextAreaElement>;

    validationErrors?: string[];
};

export function ComposeField({
    messageParts,
    charAndFragmentInfo,
    customMessage,
    onCustomMessageChange,
    validationErrors,
}: ComposeFieldProps) {
    return (
        <Ds.Form.Field name="message-body">
            <Ds.Form.Label>Message (optional)</Ds.Form.Label>
            <Ds.Form.Description>
                Add an additional message to the reminder.
            </Ds.Form.Description>
            <RoundedMessageBox backgroundColor="cloud" p="1">
                <Ds.Flex gap="2" flexDirection="column">
                    <Ds.Text>
                        {messageParts.greeting}
                        {`\n`}
                        {messageParts.templateText}
                    </Ds.Text>

                    <Ds.Form.Control>
                        <VerticalResizeTextarea
                            id="message-body"
                            value={customMessage}
                            onChange={onCustomMessageChange}
                            data-testid="message-body"
                            autoResize
                            isInvalid={!!validationErrors?.length}
                            rows={4}
                        />
                    </Ds.Form.Control>

                    <Ds.Text>{messageParts.linkText}</Ds.Text>
                    <Ds.Text>{messageParts.messageSignoff}</Ds.Text>
                </Ds.Flex>
            </RoundedMessageBox>
            <Ds.Flex gap="1" justifyContent="space-between">
                {validationErrors?.map((error) => {
                    return error === reduceReminderMessage ? (
                        <CharLimitErrorMessage key={error} />
                    ) : (
                        <Ds.Form.Error key={error}>{error}</Ds.Form.Error>
                    );
                })}
                <Ds.Box mt="0.5" ml="auto">
                    <FragmentsText size="small" weight="bold">
                        {charAndFragmentInfo}
                    </FragmentsText>
                </Ds.Box>
            </Ds.Flex>
        </Ds.Form.Field>
    );
}
